/**
 * EmptyNotificationState - Empty state view for notifications
 *
 * Matches Xamarin EmptyListView.xaml (HeightRequest=500 in NotificationListMobile.xaml):
 * - Grid: RowSpacing=25, Padding=10, VerticalOptions=Center
 * - Row 0 (*): SvgCachedImage — no_notification.svg
 * - Row 1 (Auto): Header — PoppinsBold, FontSize=20(Phone), TextColor=#243743, Center
 * - Row 2 (Auto): Body — PoppinsRegular, FontSize=14(Phone), TextColor=#243743, Center, WordWrap
 *
 * ViewModel sets:
 * - ImageSource = ImageConstant.NoNotification
 * - MessageHeader = "No Notification!" (AppResources.NoNotificationLbl)
 * - MessageBody = "There are no notifications for the past 24 hours." (AppResources.NoNotificationBodyLbl)
 */

import { useTranslation } from 'react-i18next';

import { IMAGE_CONSTANTS } from '@/constants';

export function EmptyNotificationState() {
  const { t } = useTranslation();
  return (
    /* Matches Xamarin: EmptyListView HeightRequest=500, Grid RowSpacing=25, Padding=10, VerticalOptions=Center */
    <div className="flex h-full flex-col items-center justify-center gap-[25px] p-[10px]">
      {/* Row 0: SVG image — constrained size to prevent overflow */}
      <img
        src={IMAGE_CONSTANTS.noNotification}
        alt=""
        className="max-h-[400px] w-auto object-contain"
        aria-hidden="true"
      />
      {/* Row 1: Header — PoppinsBold, FontSize=20(Phone), TextColor=#243743, Center */}
      <h3 className="text-center font-poppins text-[20px] font-bold text-[#243743]">
        {t('notification.noNotificationHeader')}
      </h3>
      {/* Row 2: Body — PoppinsRegular, FontSize=14(Phone), TextColor=#243743, Center, WordWrap */}
      <p className="text-center font-poppins text-[14px] text-[#243743]">
        {t('notification.noNotificationBody')}
      </p>
    </div>
  );
}
